import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export default class SearchCriteria extends Component {
  renderTitle = text => text.replace(/_/g, ' ');

  defaultChangeHandler = key => this.props.handleClearFilterParam(key);

  renderSearchCriteria = (key, value) => {
    if (_.isArray(value)) {
      return value.map(item =>
        this.renderSearchParam(key, item.value || item, item.label, () =>
          this.props.handleClearMultipleFilterParam(key, item)
        )
      );
    }

    if (key === 'event') {
      return this.renderSearchParam(key, value.label);
    }

    return this.renderSearchParam(key, value);
  };

  renderSearchParam = (key, value, label = value, onChangeHandler = () => this.defaultChangeHandler(key)) => (
    <div
      key={value}
      className='mr-2 d-flex align-items-center'
    >
      <button
        value={value}
        onClick={onChangeHandler}
        className='button button-primary button-small'
      >
        <div className='mr-2'>
          <span className='text-capitalize'>{this.renderTitle(key)}:</span> {label}
        </div>
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );

  render () {
    const { appliedFilterParams } = this.props;

    if (!appliedFilterParams.length) {
      return null;
    }

    return (
      <div className='d-flex align-items-center flex-wrap mb-4'>
        <div className='mr-3'>
          <strong>Filtered By:</strong>
        </div>
        {appliedFilterParams.map(({ key, value }) => this.renderSearchCriteria(key, value))}
      </div>
    );
  }
}

SearchCriteria.propTypes = {
  appliedFilterParams: PropTypes.array,
  handleClearFilterParam: PropTypes.func,
  handleClearMultipleFilterParam: PropTypes.func
};

SearchCriteria.defaultProps = {
  appliedFilterParams: []
};



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/SearchCriteria/index.js